import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Popover } from 'antd'
import i18n from 'i18n'
import React, { memo } from 'react'

import { Tooltip } from '../../antd/tooltip'
import { URL_AA_SUPPORT, URL_ZENDECK, ZENDECK_SERVICE_NAME, ZENDECK_TICKET_FORM_ID } from '../../constants/app'
import { ACLinkStyled, FaqWrapperClass } from './styles'

const FaqComponent = (props: { userInfo: any; currentOffice: any }) => {
  const { userInfo, currentOffice } = props
  const zendeckQueryParams = {
    identification_code: currentOffice?.identification_code,
    mail: userInfo?.email,
    office_type_id: `${currentOffice?.id}`,
    service_name: ZENDECK_SERVICE_NAME,
    ticket_form_id: ZENDECK_TICKET_FORM_ID,
    user_identification_code: userInfo?.identification_code,
  }

  return (
    <Popover
      overlayClassName={FaqWrapperClass}
      placement="bottomRight"
      arrowPointAtCenter
      trigger="click"
      content={
        <div>
          <ACLinkStyled href={URL_AA_SUPPORT} target="_blank" rel="noreferrer">
            {i18n.t('components.MainHeader.faq.support_site')}
          </ACLinkStyled>
          <ACLinkStyled
            href={`${URL_ZENDECK}?${new URLSearchParams(zendeckQueryParams).toString()}`}
            target="_blank"
            rel="noreferrer"
          >
            {i18n.t('components.MainHeader.faq.inquiry_form')}
          </ACLinkStyled>
        </div>
      }
    >
      <span className="header-icon">
        <Tooltip
          arrowPointAtCenter
          placement="bottom"
          overlayStyle={{ pointerEvents: 'none' }}
          content={i18n.t('components.MainHeader.faq.tooltip')}
        >
          <FontAwesomeIcon icon={faQuestionCircle} style={{ fontSize: 18, marginTop: 3, cursor: 'pointer' }} />
        </Tooltip>
      </span>
    </Popover>
  )
}

export default memo(FaqComponent)
